import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AppShell from './layout/AppShell';
import ProjectLayout from './layout/ProjectLayout';
import Login from './pages/Login';
import SsoLanding from './pages/SsoLanding';
import Placeholder from './pages/Placeholder';
import PortfolioHome from './pages/PortfolioHome';
import MyCalendar from './pages/MyCalendar';
import MyWork from './pages/MyWork';
import CheckinsPage from './pages/CheckinsPage';
import PointsPage from './pages/PointsPage';
import PublicDoc from './pages/PublicDoc';
import PublicForm from './pages/PublicForm';
import FormsScreen from './pages/project/FormsScreen';
import TimePage from './pages/TimePage';
import WorkloadsScreen from './pages/WorkloadsScreen';
import WorkspaceReports from './pages/WorkspaceReports';
import ProjectReport from './pages/project/ProjectReport';
import ActivityScreen from './pages/project/ActivityScreen';
import DiscussionScreen from './pages/project/DiscussionScreen';
import DocsScreen from './pages/project/DocsScreen';
import FilesScreen from './pages/project/FilesScreen';
import ProjectSettings from './pages/project/ProjectSettings';
import RoadmapScreen from './pages/project/RoadmapScreen';
import TasksScreen from './pages/project/TasksScreen';
import { isLoggedIn } from './lib/auth';

function RequireAuth({ children }) {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/sso-login" element={<SsoLanding />} />
      <Route path="/sso" element={<SsoLanding />} />
      <Route path="/shared/doc/:token" element={<PublicDoc />} />
      <Route path="/f/:slug" element={<PublicForm />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<PortfolioHome />} />
        <Route path="projects/:projectId" element={<ProjectLayout />}>
          <Route index element={<TasksScreen />} />
          <Route path="roadmap" element={<RoadmapScreen />} />
          <Route path="discussion" element={<DiscussionScreen />} />
          <Route path="docs" element={<DocsScreen />} />
          <Route path="files" element={<FilesScreen />} />
          <Route path="forms" element={<FormsScreen />} />
          <Route path="report" element={<ProjectReport />} />
          <Route path="activity" element={<ActivityScreen />} />
          <Route path="settings" element={<ProjectSettings />} />
        </Route>
        <Route path="my-work" element={<MyWork />} />
        <Route path="calendar" element={<MyCalendar />} />
        <Route path="time" element={<TimePage />} />
        <Route path="checkins" element={<CheckinsPage />} />
        <Route path="points" element={<PointsPage />} />
        <Route path="workloads" element={<WorkloadsScreen />} />
        <Route path="reports" element={<WorkspaceReports />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
